import * as _4 from 'lodash4';
import { slotType } from '../../global/builders/ap_generic_slot_builder';
import { ap_term_course_status_group_type } from '../../global/strategies/ap_term_course_status_group_strategy';
export class APAlternatePlanDetailsSlot {
  readonly id: number;
  desc: string;
  min_credits: number;
  max_credits: number;
  slot: number;
  slot_type: slotType;
  cd: string | null;
  status: ap_term_course_status_group_type;

  constructor(alternatePlanDetailsSlot: Partial<APAlternatePlanDetailsSlot>) {
    _4.merge(this, alternatePlanDetailsSlot);
  }

  static build(alternatePlanDetailsSlot: Partial<APAlternatePlanDetailsSlot>): APAlternatePlanDetailsSlot {
    return new APAlternatePlanDetailsSlot(alternatePlanDetailsSlot);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/builders/ap_alternate_plan_details_slot_builder.ts